<h1> EDITORIAL BOARD </h1>

<div class="text">
	<p>
		Editorial board of the book series "De Cifris Koine", edited and published by the publishing house De Cifris
		Press
		for De Componendis Cifris APS. Last updated: August 2nd, 2024.
	</p>
</div>

<h2> Editor-in-chief </h2>
<div>
	<i> Massimiliano Sala</i>
	<br>
	De Componendis Cifris, Presidente
</div>

<h2> Managing Editors </h2>
<div>
	<i> Antonino Alì</i>
	<br>
	Università di Trento, Professore
	<br>
	<br>
	<i> Norberto Gavioli</i>
	<br>
	Università dell'Aquila, Professore


</div>

<h2> Editorial Board </h2>
<div>
	<i> Gianira Nicoletta Alfarano</i>
	<br>
	KU Leuven, Researcher
	<br>
	<br>
	<i> Elena Berardini</i>
	<br>
	Université de Bordeaux, Chaire de Professeur Junior
	<br>
	<br>
	<i> Martino Borello</i>
	<br>
	Université Paris 8, Maître de Conférences
	<br>
	<br>
	<i> Alessio Caminata</i>
	<br>
	Università di Genova, Ricercatore
	<br>
	<br>
	<i>Giulia Cavicchioni</i>
	<br>
	German Aerospace Center, Researcher
	<br>
	<br>
	<i> Michela Ceria</i>
	<br>
	Politecnico di Bari, Ricercatrice
	<br>
	<br>
	<i> Michele Ciampi</i>
	<br>
	University of Edinburgh, Chancellor's Fellow
	<br>
	<br>
	<i> Roberto Civino</i>
	<br>
	Università dell'Aquila, Ricercatore
	<br>
	<br>
	<i>Veronica Cristiano</i>
	<br>
	Telsy SpA, Cryptographer
	<br>
	<br>
	<i>Daniele Friolo</i>
	<br>
	Università di Roma "La Sapienza", Ricercatore
	<br>
	<br>
	<i>Tommaso Gagliardoni</i>
	<br>
	Horizen Labs, Cryptographer and Scientist
	<br>
	<br>
	<i>Giovanni Giuseppe Grimaldi</i>
	<br>
	Università di Napoli Federico II, Ricercatore
	<br>
	<br>
	<i> Annamaria Iezzi</i>
	<br>
	Université Grenoble Alpes, Maîtresse de Conférences
	<br>
	<br>
	<i>Michela Iezzi</i>
	<br>
	Banca d'Italia, Ricercatrice
	<br>
	<br>
	<i> Roberto La Scala</i>
	<br>
	Università di Bari, Professore
	<br>
	<br>
	<i> Carla Mascia</i>
	<br>
	DataKrypto, Ricercatrice
	<br>
	<br>
	<i>Barbara Masucci</i>
	<br>
	Università di Salerno, Professor
	<br>
	<br>
	<i>Carmine Monetta</i>
	<br>
	Università di Salerno, Ricercatore
	<br>
	<br>
	<i> Andrea Monti</i>
	<br>
	Università di Chieti, Docente
	<br>
	<br>
	<i> Marco Moraglio</i>
	<br>
	Università dell'Insubria, Ricercatore
	<br>
	<br>
	<i>Marzio Mula</i>
	<br>
	Universität der Bundeswehr München, Researcher
	<br>
	<br>
	<i> Giancarlo Rinaldo</i>
	<br>
	Università di Messina, Ricercatore
	<br>
	<br>
	<i> Francesco Romeo</i>
	<br>
	Università di Cassino e del Lazio Meridionale, Ricercatore
	<br>
	<br>
	<i> Carlo Sanna</i>
	<br>
	Politecnico di Torino, Ricercatore
	<br>
	<br>
	<i> Paolo Santini</i>
	<br>
	Università Politecnica delle Marche, Ricercatore
	<br>
	<br>
	<i>Daniele Taufer</i>
	<br>
	Katholieke Universiteit Leuven, Researcher
	<br>
	<br>
	<i> Lea Terracini</i>
	<br>
	Università di Torino, Professoressa
	<br>
	<br>
	<i> Marco Timpanella</i>
	<br>
	Università di Perugia, Ricercatore
	<br>
	<br>
	<i> Martina Vigorito</i>
	<br>
	EPITA Paris, Ricercatrice
	<br>
	<br>
	<i> Irene Villa</i>
	<br>
	Università di Trento, Ricercatrice
	<br>
	<br>
	<i> Ilaria Zappatore</i>
	<br>
	Université de Limoges, Maîtresse de Conférences
	<br>
	<br>
</div>
